var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmptyMvp = function SvgEmptyMvp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 90,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-32.9%",
    y: "-16.7%",
    width: "165.9%",
    height: "160%",
    filterUnits: "objectBoundingBox",
    id: "EmptyMvp_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.191597465 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-5.3%",
    y: "-5.3%",
    width: "110.6%",
    height: "110.5%",
    filterUnits: "objectBoundingBox",
    id: "EmptyMvp_svg__b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "39.463%",
    x2: "72.937%",
    y2: "85.916%",
    id: "EmptyMvp_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAC8C8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B3B3",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#EmptyMvp_svg__a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CCC",
    fillRule: "nonzero",
    cx: 40.84,
    cy: 40.822,
    rx: 37.65,
    ry: 37.633
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#888787",
    strokeWidth: 1.5,
    cx: 41,
    cy: 40.982,
    rx: 36.421,
    ry: 36.405
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#D5D5D5",
    strokeWidth: 3.6,
    cx: 41,
    cy: 40.982,
    rx: 39.2,
    ry: 39.182
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.988 78.208 52.37 80.566l4.483-5.601a29.48 29.48 0 0 1 6.135 3.243Zm-38.696-3.243 4.483 5.601-10.618-2.358a29.48 29.48 0 0 1 6.135-3.243Z",
    fill: "#888787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.157 78.208 10.618 2.358C22.876 82.925 9.899 90 9.899 90v-9.434L4 75.85c1.038-3.09 7.48-6.19 9.084-6.922h.012l5.061 9.28Zm58.988-2.359-5.899 4.717V90s-12.977-7.075-18.876-9.434l10.618-2.358 5.06-9.28h.013c1.604.73 8.046 3.832 9.084 6.921Z",
    fill: "#CBCBC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.049 68.927-5.061 9.28a29.48 29.48 0 0 0-6.135-3.242 34.968 34.968 0 0 0-3.162-1.144c-.79-.26-1.58-.495-2.36-.708a39.646 39.646 0 0 0-4.53-.955 40.861 40.861 0 0 0-12.458 0c-1.527.23-3.04.55-4.53.955-.779.213-1.57.449-2.36.708-1.061.33-2.123.708-3.161 1.144a29.48 29.48 0 0 0-6.135 3.243l-5.061-9.28h-.012l-2.005-3.692s1.64-2.877 8.08-5.224a39.771 39.771 0 0 1 5.546-1.568 75.687 75.687 0 0 1 15.867-1.462 75.687 75.687 0 0 1 15.868 1.462c1.884.388 3.737.912 5.545 1.568 6.441 2.347 8.081 5.224 8.081 5.224l-2.005 3.691h-.012Z",
    fill: "#B4B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.096 68.927h-.012c-.346.157-.922.43-1.614.783l3.114 6.225a5.895 5.895 0 0 1-2.124 7.623c-.818.515-1.687 1.061-2.559 1.618V90s12.977-7.075 18.876-9.434L18.16 78.208l-5.063-9.28Zm53.465 7.008 3.114-6.225a39.673 39.673 0 0 0-1.614-.783h-.012l-5.061 9.28-10.618 2.36C58.269 82.924 71.246 90 71.246 90v-4.824c-.872-.553-1.741-1.103-2.559-1.618a5.895 5.895 0 0 1-2.126-7.623Z",
    fill: "#B4B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.572 66.569a44.162 44.162 0 0 0-16.392 2.917 4.696 4.696 0 0 1-5.834-2.105l-3.109-5.594a11.15 11.15 0 0 0-4.158 3.45l2.005 3.69h.012l5.061 9.28a29.48 29.48 0 0 1 6.135-3.242c1.038-.436 2.1-.814 3.162-1.144.79-.26 1.58-.495 2.359-.708a39.646 39.646 0 0 1 4.53-.955 40.861 40.861 0 0 1 12.458 0c1.528.23 3.04.55 4.53.955.78.213 1.57.449 2.36.708 1.062.33 2.124.708 3.162 1.144a29.48 29.48 0 0 1 6.135 3.243l2.4-4.401-.04-.163c-2.36-2.358-15.338-7.075-24.776-7.075Z",
    fill: "#CBCBC8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#EmptyMvp_svg__b)",
    transform: "translate(12.444 12.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.58 46.5C6.202 42.29 2.388 44.06.5 39.475c-1.888-4.584 2.16-5.438 2.387-11.652C3.114 21.609-.97 22.29.906 16.81c1.875-5.48 5.544-2.276 9.673-6.425 4.13-4.15 1.311-7.016 6.277-9.54 4.966-2.523 5.747 2.286 11.338 2.286 5.591 0 6.535-4.543 11.187-2.684 4.652 1.86 2.864 5.923 6.963 9.938 4.1 4.015 7.78 1.616 9.743 6.425 1.964 4.81-2.118 7.031-2.118 12.253 0 5.221 3.836 6.248 2.118 10.412-1.717 4.164-5.104 2.056-8.934 6.113-3.83 4.056-1.305 7.565-5.988 9.694-4.683 2.13-6.599-1.715-12.137-1.452-5.538.262-6.125 4.468-10.964 2.546-4.84-1.923-3.108-5.665-7.485-9.876Z",
    fill: "url(#EmptyMvp_svg__c)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#888787",
    fillRule: "nonzero",
    cx: 28.397,
    cy: 28.384,
    rx: 19.144,
    ry: 19.135
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DBDBDA",
    d: "m32.83 51.977 1.72-8.766L28 37.186l8.805-1.058 3.66-8.14 3.72 8.11 8.815.993-6.505 6.075 1.785 8.75-7.74-4.357z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFAEAC",
    d: "M40.5 39.982 28 37.186l6.55 6.025zM40.5 39.982l-7.67 11.995 7.71-4.418 7.74 4.357zM40.5 39.982 53 37.091l-6.505 6.075zM40.465 27.988l.035 11.994 3.685-3.884z"
  })))));
};
export default SvgEmptyMvp;